/**
 * @generated SignedSource<<5622f08f7b62fa24ee3cb90b14412d51>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AgencyManagementModalDeleteMutation$variables = {
  id: string;
};
export type AgencyManagementModalDeleteMutation$data = {
  readonly softDelete: {
    readonly success: boolean | null;
  } | null;
};
export type AgencyManagementModalDeleteMutation = {
  response: AgencyManagementModalDeleteMutation$data;
  variables: AgencyManagementModalDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "SoftDelete",
    "kind": "LinkedField",
    "name": "softDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AgencyManagementModalDeleteMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AgencyManagementModalDeleteMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1217b6a30e7e355ba44209234e79ab9c",
    "id": null,
    "metadata": {},
    "name": "AgencyManagementModalDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation AgencyManagementModalDeleteMutation(\n  $id: ID!\n) {\n  softDelete(id: $id) {\n    success\n  }\n}\n"
  }
};
})();

(node as any).hash = "06afe3a9db7a4b1702a47597ba5525da";

export default node;
